"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionAndOr = void 0;
var ConditionAndOr;
(function (ConditionAndOr) {
    ConditionAndOr["AND"] = "and";
    ConditionAndOr["OR"] = "or";
})(ConditionAndOr = exports.ConditionAndOr || (exports.ConditionAndOr = {}));
